import { Outlet, useParams } from "react-router";
import { createContext, useContext, useEffect, useState } from "react";
// import { IDisributorInfoExtend, IPartnerExtend } from "./DistributorDetail";
import { apiRemote } from "@/api/wp-api";
import { useAlert } from "@/contexts/AlertContext";
import { decodeId } from "@/utils/decodeId";
import { useCustomBreadcrumb } from "@/contexts/CustomBreadcrumb";
import { ITwinSpace } from "@/api";

// Define the context interface
export interface TwinspaceContextType {
    twinspace: ITwinSpace;
    removeRoom: (room_id: string) => Promise<void>;
    loadDataMyTwinspace: () => Promise<any>;
}
const TwinspaceContext=createContext<TwinspaceContextType>({} as any);

export function TwinspaceLayout(){
    const { id } = useParams<{ id: string }>(); 
    const alert=useAlert();
    
    const [twinspaceData, setTwinspaceData] = useState<ITwinSpace>({}as any);

    const loadDataMyTwinspace=()=>{
        return apiRemote.getMyTwinSpace().catch((err: any) => {
            alert.error(err.message);
            return {} as ITwinSpace; // Trả về giá trị mặc định khi có lỗi
        });
    }

    const removeRoom = (room_id: string) => {
        console.log("removeRoom", room_id);
    
        return apiRemote.removeRoom({
            room_id: room_id
        }).then((res) => {
            if (res.code === 200 || res.code == 0) {
                alert.success("Remove room successfully");
            } else {
                alert.error(res.message);
            }
        }).catch((err) => {
            alert.error(err.message);
            throw err;
        });
    };

    useEffect(()=>{
        // alert.showWait();
        // console.log(`from layout ${id}`);

        // var twinspaceDataLoaded = loadDataMyTwinspace();
        

        // Promise.all([twinspaceDataLoaded]).then(([resTwinspace])=>{
        //     if (resTwinspace) {
        //         setTwinspaceData(resTwinspace);
        //     }
        // }).catch((err)=>{
        //     alert.error(err.message);
        // }).finally(()=>{
        //     alert.hideWait();
        // });



    },[id]);
    return (
        <TwinspaceContext.Provider value={{twinspace: twinspaceData, removeRoom, loadDataMyTwinspace}}>
            <Outlet />
        </TwinspaceContext.Provider>
    )
}

export function useTwinspaceContext(){
    return useContext(TwinspaceContext);
}